import {
  Box,
  Button,
  Checkbox,
  Flex,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';
import identity from 'lodash/identity';
import { useState } from 'react';

const agreementText = [
  '[필수] 서식의 내용은 사용자에 의해 수정, 보완, 삭제될 수 있으며, 서식(수정, 보완, 삭제된 경우를 포함한다)의 내용에 대하여 서식 제공자와 모두싸인은 법적 효력을 보증하지 아니합니다.',
  '[필수] "표준 서식" 등 서식의 태그는 명기된 원출처의 표시에 따른 것입니다.',
  '[필수] 서식을 그대로, 또는 수정, 보완, 삭제하여 사용함으로써 발생하는 분쟁이나 기타 어떠한 손해(제 3자와의 분쟁, 손해 포함)에 대하여 서식 제공자와 모두싸인은 법적 책임을 지지 않습니다.',
  '[필수] 사용자는 서식을 모두싸인 에디터 내에서만 사용하며, 서식의 무단 유출, 배포 등 외부 사용은 엄격히 금지됩니다.',
];

export interface FormAgreementModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function FormAgreementModal({
  isOpen,
  isLoading,
  onCancel,
  onConfirm,
}: FormAgreementModalProps) {
  const [checked, setChecked] = useState<boolean[]>(Array(agreementText.length).fill(false));

  const isAllChecked = checked.every(identity);

  return (
    <Modal isOpen={isOpen} maxWidth="sm" onClose={onCancel}>
      <ModalTitle>서식 이용 안내</ModalTitle>
      <ModalContent>
        <Text as="div" fontWeight="medium" textAlign="center">
          서식 이용을 위해 아래의 내용을 확인하고 동의해 주세요.
        </Text>
        <Flex mt={7}>
          <Flex alignItems="center" flexShrink={0}>
            <Checkbox
              checked={isAllChecked}
              display="inline-block"
              id="FormAgreementModal-check_all"
              onClick={() => setChecked(checked.map(() => !isAllChecked))}
            />
          </Flex>
          <Text
            as="label"
            color="textNeutralSlightlyLight"
            fontSize="lg"
            fontWeight="medium"
            htmlFor="FormAgreementModal-check_all"
            ml={3}
            sx={{
              cursor: 'pointer',
            }}
          >
            모두 동의합니다.
          </Text>
        </Flex>
        <Box
          bg="boxBackgroundNeutralBase"
          border="1px solid"
          borderColor="boxBorderNeutralBase"
          mt={4}
          px={7}
          py={8}
        >
          <Text as="p" color="textNeutralLight" fontSize="sm" mb={6}>
            {"'서식'"}이란 본 서식을 포함하여, 모두싸인 법률 서식을 통해 제공되는 모든 서식을
            의미합니다.
          </Text>
          <ul>
            {agreementText.map((text, index) => (
              <Flex
                as="li"
                borderTop="1px solid"
                borderTopColor="dividerNeutralBase"
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                py={4}
              >
                <Box flexShrink={0} pt={1}>
                  <Checkbox
                    checked={checked[index]}
                    id={`FormAgreementModal-check_${index}`}
                    onClick={() =>
                      setChecked(checked.map((value, idx) => (idx === index ? !value : value)))
                    }
                  />
                </Box>
                <Text
                  as="label"
                  color="textNeutralSlightlyLight"
                  htmlFor={`FormAgreementModal-check_${index}`}
                  ml={3}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  {text}
                </Text>
              </Flex>
            ))}
          </ul>
        </Box>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onCancel}>돌아가기</Button>
        <Button
          disabled={!isAllChecked}
          isLoading={isLoading}
          ml={3}
          variant="primary"
          onClick={onConfirm}
        >
          동의하기
        </Button>
      </ModalFooter>
    </Modal>
  );
}
